module.exports = __webpack_public_path__ + "entry-150bfe9b/deutsche-post-098f2ac44bd2ded3702c91318756cb7e.webp";